import React from "react";

const Reservation = () => (
  <svg
    className="reservation-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46.08 51.21"
  >
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M18.31,42.64A18.31,18.31,0,0,1,18.31,6a1,1,0,0,1,0,2A16.31,16.31,0,1,0,34.62,24.33a1,1,0,1,1,2,0A18.33,18.33,0,0,1,18.31,42.64Z"
        />
        <path
          className="cls-1"
          d="M41.88,51.21a1,1,0,0,1-.71-.29l-12-12a1,1,0,1,1,1.41-1.41l12,12a1,1,0,0,1-.71,1.71Z"
        />
        <path
          className="cls-1"
          d="M32.21,20.39l-9.41-8.32a1,1,0,0,1,1.33-1.5l7.76,6.87L44.27.41a1,1,0,0,1,1.62,1.18Z"
        />
      </g>
    </g>
  </svg>
);

export default Reservation;
